"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getYear = exports.getMonth = exports.currentYearHandler = void 0;
const currentYearHandler = () => {
  const d = new Date();
  const currentYear = d.getFullYear();
  return currentYear;
};
exports.currentYearHandler = currentYearHandler;
const getYear = date => date.getFullYear();
exports.getYear = getYear;
const getMonth = date => date.toLocaleString('en', {
  month: 'long'
});
exports.getMonth = getMonth;